import { Theme, css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { Spacing, Typography } from 'chatie-design-system';
import { Close, Icon } from 'chatie-design-system/icon';

import Image from '@components/common/Image';
import Overlay from '@components/common/Overlay';

import PeekImg from '@public/images/peek/peek_banner.png';

import { ModalButton, ModalProps, contentCSS, modalCSS } from '../common/Modal';

const containerCSS = (theme: Theme) => css`
  overflow: scroll;
  z-index: 999;
  .pink {
    background: var(
      --_pink,
      linear-gradient(55deg, #ff07f5 20.46%, #ed0064 82.76%)
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    display: inline;
  }
  .title {
    ${Typography.h4};
    text-align: center;
    line-height: 18px;
    font-weight: 700;
    margin-bottom: ${Spacing.xlarge}px;
    padding-top: ${Spacing.xhsmall}px;
  }
  .close {
    position: absolute;
    top: 8px;
    right: 8px;
  }
  input {
    max-width: 90%;
  }
  ul {
    display: flex;
    flex-direction: column;
    padding: 0 ${Spacing.medium}px;
    margin: ${Spacing.xlarge}px 0;
    gap: ${Spacing.xsmall}px;
  }
  ul > li {
    word-break: break-all;
    ${Typography.body14};
    font-size: 14px;
    list-style-type: disc;
    color: ${theme.var.gray900};
    line-height: 18.9px;
  }
  .guide-container {
    align-self: center;
  }
`;

const overlayCSS = (isOpen: boolean) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding-left: ${Spacing.medium}px;
  padding-right: ${Spacing.medium}px;

  ${isOpen
    ? css`
        transform: scale(1);
        visibility: visible;
      `
    : css`
        transition: 0.25s;
        transform: scale(0.4);
        opacity: 0;
        visibility: hidden;
      `}
`;

const PeekBannerModal = ({ ...props }: ModalProps) => {
  const { t } = useTranslation();
  const { onClose, open } = props;

  return (
    <Overlay
      {...props}
      blocking={false}
      css={overlayCSS(open)}
      onClosePageClick={onClose}
    >
      <div css={modalCSS(open)} className="modal-container">
        <div css={contentCSS}>
          {/* <Modal
            {...props}
            blocking={false}
            onClose={props.onClose}
            header={false}
          > */}
          <div css={containerCSS}>
            <div className="close" onClick={() => props.onClose()}>
              <Icon icon={Close} />
            </div>
            <div className="title">{t('엿보기 알아보기  👀')}</div>
            <ul>
              <li>
                {t(
                  '대화방 오른쪽 상단 엿보기 버튼을 활성화하면 나의 재미있는 대화방이 공개돼요!'
                )}
              </li>
              <div className="guide-container">
                <Image
                  src={PeekImg}
                  alt={t('엿보기 가이드 이미지')}
                  height={29}
                  width={261}
                />
              </div>
              <li>
                {t(
                  '나의 대화도 공개하고 다른 채티즈의 대화를 탭하며 엿보기 해보세요!'
                )}
              </li>
            </ul>
            <ModalButton text={t('확인했어요')} onClick={() => onClose()} />
          </div>
          {/* </Modal> */}
        </div>
      </div>
    </Overlay>
  );
};

export default PeekBannerModal;
